import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { TermsPolicyDialogComponent } from './pages/components/terms-policy-dialog/terms-policy-dialog.component';
import { environment } from 'src/environments/environment';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { InstitutionalService } from './services/institutional.service';

import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';//testpago
import { StorageService } from './services/shared/storage.service';

const PRODUCT_BASIC_MONTH = environment.basicMonth;//testpago
const PRODUCT_PRO_MONTH = environment.proMonth;//testpago

const PRODUCT_PRO_YEAR = environment.proYear;//testpago
const PRODUCT_BASIC_YEAR = environment.basicYear;//testpago
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;

  public labels = [];
  languaje;
  loadingRouteConfig: boolean;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private translateService: TranslateService,
    private storageService: StorageService,
    private authS: AuthService,
    private institutionalService: InstitutionalService,
    public dialog: MatDialog,
    private router: Router,

    private store: InAppPurchase2,//testpago
  ) {

    platform.ready().then(() => {

      if (this.platform.is('mobile')) {
        //PAYMENT MOBILE
        // this.store.verbosity = this.store.DEBUG;//testpago
        // this.store.validator = environment.foveaValidator;
        // this.registerProductsMOBILE();
      }

      this.storageService.get('ezze_languaje').then((languaje) => {
        if (languaje) {
          this.languaje = languaje;
        }
        else {
          this.languaje = "en";
          this.storageService.set('ezze_languaje', "en");
        }
        this.translateService.setDefaultLang(this.languaje);
        this.translateService.use(this.languaje);

        this.storageService.get('token').then((token) => {
          if (token) {
            this.authS.getUserFromToken(token).subscribe((res: any) => {
              if (res.data) {
                if (this.platform.is('mobile')) {
                  // this.store.applicationUsername = res.data?.id_user;
                }

                /* user institutional
                en /home /login 
                se está aplicando esta condicion porque se trae el getUserFromToken en esas rutas
                /success-payment no se aplica ya que un institucional no puede comprar planes ya que tiene ligado uno
                */

                //PENDIENTE INSTITUCIUONES ILLUNOTES V2
                if (res.data.subscription?.id_institution != null) {

                  //pendiente TODO: VERSION 2 ILLU
                  this.institutionalService.getInstitutionByID(token, res.data.subscription.id_institution.id_institution)
                    .subscribe((resInst: any) => {


                      if (resInst.status == 200) {
                        res.data.institution = resInst.data;

                        localStorage.setItem('logoInstitution', res.data.institution?.picture);

                      } else if (res.message == "INSTITUCION NO ENCONTRADA") {
                        res.data.id_institution = null;
                      }
                    });
                } else {
                  localStorage.setItem('logoInstitution', "");
                }

                this.authS.userData.next(res.data);
                //this.authS.updateUserData(res.response);
                const user = {
                  role: res.data.user_role.id_user_role,
                  name: res.data.user_role.name
                };
                this.authS.userRole.next(user)
                this.initializeApp();
              }
            });
          }
        });
      });
    });
  }

  registerProductsMOBILE() {//TESTPAGO
    this.store.register({
      id: PRODUCT_BASIC_MONTH,
      type: this.store.PAID_SUBSCRIPTION,
    });

    this.store.register({
      id: PRODUCT_PRO_MONTH,
      type: this.store.PAID_SUBSCRIPTION,
    });

    this.store.register({
      id: PRODUCT_BASIC_YEAR,
      type: this.store.PAID_SUBSCRIPTION,
    });

    this.store.register({
      id: PRODUCT_PRO_YEAR,
      type: this.store.PAID_SUBSCRIPTION,
    });

    this.store.refresh();
  }

  versionIlluNotes = environment.versionIlluNotes;

  initializeApp() {
    this.platform.ready().then(() => {
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
  }

  showFooter: boolean;
  ngOnInit() {
    this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((res: any) => {
      const presentationRE = /^\/(menu)\/(presentation|edit-presentation)\/\d+\/?(joined|speaker|own)?/.test(res.url)
      if (presentationRE) {
        this.loadingRouteConfig = true;
      }

    });
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((res: any) => {
      const presentationRE = /^\/(menu)\/(presentation|edit-presentation)\/\d+\/?(joined|speaker|own)?/.test(res.url)
      if (presentationRE) {
        this.loadingRouteConfig = false;
      }
    });
    this.router.events.pipe(filter(e => e instanceof NavigationCancel)).subscribe(() => {
      this.loadingRouteConfig = false;
    });
    this.authS.showFooterIllunotes.subscribe(res => {
      this.showFooter = res
    })
  }

  /**
   * 
   * @param typeAction terms or policy
   */
  termsAndConditions(typeAction: string) {
    this.dialog
      .open(TermsPolicyDialogComponent, {
        disableClose: true,
        data: {
          acceptButton: false,
          type: typeAction
        },
        panelClass: 'terms-dialog'
      })
      .afterClosed()
      .subscribe((confirmado: boolean) => {
        if (confirmado) {
          //todo: missing handler
        } else {
          //todo: missing handler
        }
      });
  }

}
